import {Component, EventEmitter, forwardRef, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {ControlValueAccessor, FormArray, FormBuilder, FormGroup, NG_VALUE_ACCESSOR, Validators} from '@angular/forms';
import {VehiclesService} from '../../../vehicles/vehicles.service';

@Component({
  selector: 'app-mapping',
  templateUrl: './mapping.component.html',
  styleUrls: ['./mapping.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef( () => MappingComponent),
      multi: true
    }
  ]
})
export class MappingComponent implements OnInit, ControlValueAccessor, OnChanges {

  @Input() columnData: any;
  @Output() emitter = new EventEmitter<any>();
  public formMapping: FormGroup;
  public value: any;
  public CallType: any;

  constructor(
    private fb: FormBuilder,
    private _callType: VehiclesService
  ) {
    this.createForm();
  }

  propagateChange = (_: any) => {};

  ngOnInit() {
    this.getCallTypeData();
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  get itemsForm(): FormArray{
    return this.formMapping.get('items') as FormArray;
  }

  /**
   * @Metodo getCallTypeData
   * @description para traer todos los calltype.
   * */
  getCallTypeData() {
    this._callType.getCallType().subscribe(success => {
      this.CallType = success;
    });
  }

  /**
   * @Metodo createForm
   * @description para crear el formulario
   * */
  createForm() {
    this.formMapping = this.fb.group({
      items: this.fb.array([this.fb.group({
        value: [null],
        mappingTo: ['', [Validators.required]],
        dependingColumn: null
      })
      ])
    });
    this.formMapping.get('items').valueChanges.subscribe(val => {
      this.propagateChange(val);
    });
  }

  /**
   * @Metodo createItem
   * @description para crear campos en array
   * */
  createItem() {
    const item = this.formMapping.controls['items'] as FormArray;
    item.push(
      this.fb.group({
        value: [null],
        mappingTo: ['', [Validators.required]],
        dependingColumn: null
      })
    );
    item.updateValueAndValidity();
  }


  verificFormValid() {
    this.emitter.emit(this.formMapping.valid);
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
  }

  setDisabledState(isDisabled: boolean): void {
  }

  writeValue(obj: any): void {
  }


}



// WEBPACK FOOTER //
// ./src/app/pages/import-template/component/mapping/mapping.component.ts